function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "arrow_small_button",
  "data-name": "arrow small button",
  transform: "translate(-11662 -1616)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "placeholder",
  cx: 18,
  cy: 18,
  r: 18,
  transform: "translate(11662 1616)",
  fill: "rgba(245,140,57,0.5)"
}), /*#__PURE__*/React.createElement("g", {
  id: "arrow_icon",
  "data-name": "arrow icon"
}, /*#__PURE__*/React.createElement("path", {
  id: "arrow_icon-2",
  "data-name": "arrow icon",
  d: "M11682.009,1628.991l-7,7.428,1.726,1.535,4.264-4.86v9.916l2.034-.064v-9.852l4.284,4.86,1.69-1.651Z",
  transform: "translate(-2 -2)",
  fill: "#fff"
})));

var SvgArrowCircle = function SvgArrowCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow_circle.34560caf.svg";
export { ForwardRef as ReactComponent };